// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { xBaseTheme } from "@turnerBlueprint/XDL/types";
import { color, ellipsis, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 100%;
                word-wrap: break-word;
                ${xScreen("lte", "sm")} {
                    ${ellipsis(1)}
                }
            `,
        },
        css: css`
            flex-wrap: ${({ noWrap }: any) => (noWrap ? "nowrap" : "wrap")};

            ${TypographyStyle}:last-child {
                ${ellipsis(1)}
            }
            ${IconWrapper} {
                margin: 0 8px;
                flex: 0 0 6px;
                &,
                svg {
                    height: auto;
                    width: 6px;
                    color: ${color("common.ui6")};
                }
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
